import React, {
  memo,
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from 'react';
import { Table, Button } from 'antd';
// import { number_format } from '@utils/widget';
import PowerBiLink from '../powerbiEmbed';
import {
  expandColumns,
  defaultColumns,
  officeExpandColumns,
  officeDefaultColumns,
} from './columnData';
import { Loading } from '@components';
import { number_format } from '@utils/widget';
import { CURRENT } from '@modules/analysis/detail/subsidiaries/subsidiaries';
import OfficeSwitch from '@modules/analysis/detail/subsidiaries/officeSwitch';
import moment from 'moment';
// import CountryFilter from '@modules/analysis/detail/headcountSalesByCountry/HeadcountSalesTable/CountryFilter';
import GridFilterContext from '@modules/analysis/detail/subsidiaries/grid/gridFilterContext';
import GridFilterDropdown from '@modules/analysis/detail/subsidiaries/grid/gridFilterDropdown';
import FilterIcon from '@modules/analysis/detail/subsidiaries/grid/filterIcon';

function getAnnotationText(expand, showOffice, stateOfCurFuSwitch, date) {
  if (stateOfCurFuSwitch !== CURRENT) {
    return '';
  }
  if (!showOffice) {
    return expand
      ? `Employee Headcount data reflects data pulled from Dun & Bradstreet database,  updated on ${
          date ? moment(date).format('MM/DD/YYYY') : '-'
        } based on most recent update to Headquarter headcount.`
      : 'Source: Dow Jones.';
  }
  return 'Employee Headcount data reflects data pulled from most recent financial statements reported to the SEC.';
}

// function expandSubsidiaryChildren(children, key) {
//   return children.map((data, i) => {
//     if (data.children && data.children.length !== 0) {
//       return {
//         ...data,
//         loc: data.loc || '-',
//         key: `${key}-${i}`,
//         children: expandSubsidiaryChildren(data.children, `${key}-${i}`),
//       };
//     }
//     return {
//       ...data,
//       loc: data.loc || '-',
//       key: `noChild-${key}-${i}`,
//     };
//   });
// }

const TdCell = (props) => {
  const { onMouseEnter, onMouseLeave, ...restProps } = props;
  return <td {...restProps} />;
};

const TR = (props) => {
  const { onMouseEnter, onMouseLeave, ...restProps } = props;
  return <tr {...restProps} />;
};

const GridTable = ({
  subsidiaries = [],
  officeLocations = [],
  subsidiaryFilterOptions,
  officeFilterOptions,
  subsidiariesCount = 0,
  branchesCount = 0,
  officeCount = 0,
  expand,
  isShownInModal,
  stateSwitch,
  editButton,
  stateOfCurFuSwitch,
  tabKey,
  reportDate = [],
}) => {
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [expandAll, setExpandAll] = useState(false);
  const [columns, setColumns] = useState(defaultColumns);
  const [dataSource, setDataSource] = useState([]);
  const [show, setShow] = useState(true);
  const [showOffice, setShowOffice] = useState(false);
  const currentFilterOptions = showOffice
    ? officeFilterOptions
    : subsidiaryFilterOptions;
  const cachedKeys = useRef([]);
  const [filters, setFilters] = useState({});

  const rowMatched = useCallback(function (filters, record) {
    return Object.entries(filters).every((i) => {
      const [field, selectedKeys] = i;
      if (
        !selectedKeys?.length ||
        (typeof record[field] !== 'boolean' && !record[field]) ||
        selectedKeys.includes(record[field])
      ) {
        // console.log('record.key', record.key);
        cachedKeys.current.push(record.key);
        return true;
      }
      return false;
    });
    // for (const key in filters) {
    //   const selectedKeys = filters[key];
    //   if(!selectedKeys?.length || !record[key]) continue;
    //   if (selectedKeys.some(i => record[key] === i )) return true;
    // }
    // return false;
  }, []);

  const filteredDataSource = useMemo(() => {
    if (Object.values(filters).some((i) => i.length === 0)) {
      return [];
    }

    const validFilters = {};
    for (const key in filters) {
      if (
        filters[key]?.length &&
        filters[key]?.length < currentFilterOptions[key]?.length
      ) {
        validFilters[key] = filters[key];
      }
    }
    if (Object.keys(validFilters).length) {
      const tempDataSource = JSON.parse(JSON.stringify(dataSource));
      // eslint-disable-next-line no-inner-declarations
      function recurse(record) {
        if (record.children && record.children.length) {
          record.children = record.children.filter(recurse);
        }
        const hasChildren = record.children?.length;
        if (rowMatched(validFilters, record) || hasChildren) {
          if (hasChildren) {
            cachedKeys.current.push(record.key);
          }
          return true;
        }
        return false;
      }
      const result = tempDataSource.filter(recurse);
      setTimeout(() => {
        setExpandedRowKeys(Array.from(new Set(cachedKeys.current)));
        cachedKeys.current = [];
      }, 0);
      return result;
    }
    return dataSource;
  }, [filters, dataSource, currentFilterOptions, stateOfCurFuSwitch]);

  // const spawnSubsidiariesTableData = useCallback(
  //   (originSubsidiaries) =>
  //     originSubsidiaries.map((data, index) => {
  //       if (data.children?.length !== 0) {
  //         return {
  //           ...data,
  //           loc: data.loc || '-',
  //           key:
  //             data.children && data.children.length !== 0
  //               ? `${index}`
  //               : `noChild-${index}`,
  //           children: expandSubsidiaryChildren(data.children, index),
  //         };
  //       }
  //       return {
  //         ...data,
  //         loc: data.loc || '-',
  //         key:
  //           data.children && data.children.length !== 0
  //             ? `${index}`
  //             : `noChild-${index}`,
  //         // children: data.branchList,
  //       };
  //     }),
  //   [],
  // );

  // useEffect(() => {
  //   setDataSource(spawnSubsidiariesTableData(subsidiaries));
  // }, [subsidiaries]);

  const onFilterSelect = useCallback((selectedKeys, filterKey) => {
    setFilters((filterState) => {
      filterState[filterKey] = selectedKeys;
      return {
        ...filterState,
      };
    });
  }, []);

  const addFilterToColumn = useCallback(
    (column, optionData = {}) => {
      const { key } = column;

      // const onFilter = (value, record) => {
      //   const valueLowerCase = value?.toLowerCase?.();
      //   return record.completeLoc?.toLowerCase?.().includes(valueLowerCase)
      //     || getDescendantValues(record, dataIndex).some(i => i.includes(valueLowerCase));
      // }
      const filterDropdown = ({ visible, confirm }) => (
        <GridFilterDropdown
          filterKey={key}
          options={optionData[key]}
          onSelectedKeyChange={onFilterSelect}
          visible={visible}
          confirm={confirm}
        />
      );

      setFilters((filterState) => {
        // init filter selected keys
        if (!filterState[key]) {
          filterState[key] = optionData[key] || [];
        }
        return filterState;
      });
      return {
        ...column,
        // onFilter,
        filterDropdown,
        filterIcon: (
          <FilterIcon filterKey={key} optionsLength={optionData[key]?.length} />
        ),
      };
    },
    // [filters],
    [],
  );

  // const add = () => {
  //   // setDataSource((old) => {
  //   //
  //   //   return [{
  //   //     key: 'hello',
  //   //       "type": "Branch",
  //   //       "duns": "602461019",
  //   //       "companyName": "1111111111111111",
  //   //       "loc": "1111111111111111",
  //   //       "completeLoc": "tableColumns1111",
  //   //       "employees": null,
  //   //       "sales": null,
  //   //       "reportingCurrency": null,
  //   //       "parentHeadQuartersDuns": "051957769",
  //   //       "children": []
  //   //   }, ...old]
  //   // });
  //   // setColumns((old) => {
  //   //   old[0].title = "hello";
  //   //   return [...old]
  //   // });
  // }

  useEffect(() => {
    let result = [];
    let columnWithFilter = [];
    setFilters({});
    const filterOptions = showOffice
      ? officeFilterOptions
      : subsidiaryFilterOptions;
    if (showOffice) {
      result = [...(expand ? officeExpandColumns : officeDefaultColumns)];
      columnWithFilter = expand
        ? ['countryName', 'state', 'city', 'share']
        : ['countryName', 'share'];
    } else {
      result = [...(expand ? expandColumns : defaultColumns)];
      columnWithFilter = expand
        ? ['companyName', 'type', 'duns', 'completeLoc', 'share']
        : ['companyName', 'loc', 'share'];
    }
    for (let i = 0; i < result.length; i++) {
      const column = result[i];
      if (columnWithFilter.includes(column.key)) {
        result[i] = addFilterToColumn(column, filterOptions || {});
      }
    }
    setColumns(result);
  }, [expand, showOffice, stateOfCurFuSwitch]);

  useEffect(() => {
    setShowOffice(false);
    setExpandedRowKeys([]);
  }, [stateOfCurFuSwitch]);

  // useEffect(() => {
  //   if (showOffice) {
  //     setColumns(expand ? officeExpandColumns : officeDefaultColumns);
  //   } else {
  //     setColumns(expand ? expandColumns : defaultColumns);
  //   }
  // }, [expand, showOffice]);

  const getExpandedRowKeys = () => {
    const ar = [];
    function f(children) {
      children.map((data, index) => {
        if (data.key.indexOf('noChild') === -1) {
          ar.push(data.key);
        }
        return f(data.children);
      });
    }
    dataSource.map((data, index) => {
      if (data.key.indexOf('noChild') === -1) {
        ar.push(data.key);
      }
      if (data.children && data.children.length > 0) {
        return f(data.children);
      }
      return {};
    });
    return ar;
  };

  const handleExpandAll = () => {
    const keys = getExpandedRowKeys();
    if (!expandAll) {
      setExpandedRowKeys(keys);
    } else {
      setExpandedRowKeys([]);
    }
    setExpandAll((state) => !state);
    if (branchesCount > 600) {
      transitionWithLoading();
    }
  };

  // if dataSource to large, render will block, show loading component to provide better experience
  const transitionWithLoading = useCallback(() => {
    setShow(false);
    setTimeout(() => {
      setShow(true);
    }, 300);
  }, []);

  const handleCollapseOne = (record) => {
    const { key } = record;
    setExpandedRowKeys((state) => state.filter((item, index) => item !== key));
  };
  const handleExpandOne = (record) => {
    const { key } = record;
    setExpandedRowKeys((state) => [...state, key]);
  };
  const changeShowOffice = useCallback((checked) => {
    setShowOffice(checked);
  }, []);

  useEffect(() => {
    transitionWithLoading();
    if (showOffice) {
      setDataSource(officeLocations);
      setExpandedRowKeys([]);
    } else {
      setDataSource(subsidiaries || []);
    }
  }, [showOffice, subsidiaries, officeLocations]);

  const iconIndicator = showOffice ? (
    <>
      <span className="appkiticon icon-location-fill a-font-10 a-text-orange" />
      &nbsp;Headquarter
    </>
  ) : (
    <>
      <span className="appkiticon icon-radio-outline a-font-10 a-text-orange" />
      &nbsp;Subsidiary &nbsp; &nbsp;
      <span className="appkiticon icon-radio-fill a-font-10 a-text-orange" />
      &nbsp;Principal Subsidiary
    </>
  );

  return (
    <GridFilterContext.Provider value={filters}>
      <div className="bottom subsidiaries-table-wrapper">
        {!expand && !isShownInModal && (
          <div className="top">
            {stateSwitch}
            <PowerBiLink />
            <div className="legends">{iconIndicator}</div>
          </div>
        )}
        {!isShownInModal && (
          <>
            <div className="count">
              {expand && (
                <div className="count-right">
                  {stateSwitch}
                  {editButton}
                  <PowerBiLink />
                  <div className="count-bottom">{iconIndicator}</div>
                </div>
              )}
            </div>
            <div
              className={`count second-div ${expand ? '' : 'not-in-expand'}`}
            >
              <OfficeSwitch checked={showOffice} onChange={changeShowOffice} />
              <div className="subs-count">
                {showOffice ? (
                  <span>
                    Office Locations:&nbsp;{number_format(officeCount)}
                  </span>
                ) : (
                  <>
                    <span>
                      Subsidiaries:&nbsp;{number_format(subsidiariesCount)}
                    </span>
                    <span className="branch-count">
                      Branches:&nbsp;{number_format(branchesCount)}{' '}
                    </span>
                  </>
                )}
              </div>
            </div>
          </>
        )}
        {isShownInModal && (
          <div className="modal-switcher">
            <OfficeSwitch onChange={changeShowOffice} />
          </div>
        )}

        {!isShownInModal && !showOffice && (
          <div className="expand-all">
            <Button
              type="link"
              onClick={handleExpandAll}
              className="expand-all-btn"
            >
              {!expandAll ? 'Expand All' : 'Collapse All'}
            </Button>
          </div>
        )}
        {show ? (
          <Table
            columns={columns}
            dataSource={filteredDataSource}
            className={`subsidiaries-table scroll-bar ${
              showOffice ? 'office-table' : ''
            }`}
            pagination={false}
            scroll={{ y: '25rem' }}
            indentSize={12}
            showSorterTooltip={false}
            expandedRowKeys={expandedRowKeys}
            expandIcon={({ expanded, onExpand, record }) => {
              const { children } = record;
              if (children && children.length === 0) {
                return (
                  <span
                    className="appkiticon icon-right-chevron-fill a-font-10  arrow-color-disable a-text-grey"
                    style={{ opacity: 0 }}
                  />
                );
              }
              if (expanded && children) {
                return (
                  <span
                    className="appkiticon icon-down-chevron-fill a-font-10  arrow-color"
                    onClick={(e) => {
                      handleCollapseOne(record);
                    }}
                  />
                );
              }
              if (!expanded && children) {
                return (
                  <span
                    className="appkiticon icon-right-chevron-fill a-font-10 arrow-color"
                    onClick={(e) => handleExpandOne(record)}
                  />
                );
              }
            }}
            components={{
              body: { cell: TdCell, row: TR },
            }}
          />
        ) : (
          <Loading
            style={{ width: '100%', display: 'flex', justifyContent: 'center' }}
          />
        )}
        {!isShownInModal && (
          <div className="footer">
            {getAnnotationText(
              expand,
              showOffice,
              stateOfCurFuSwitch,
              reportDate[tabKey],
            )}
          </div>
        )}
      </div>
    </GridFilterContext.Provider>
  );
};

export default memo(GridTable);
